import React from "react";
import { NotificationMessage } from "../models/models";
import { Alert, ThemeProvider, createTheme } from "@mui/material";

const FormNotificationMessage = (formNotificationMessage: NotificationMessage) => {
  const theme = createTheme({
    components: {
      MuiAlert: {
        styleOverrides: {
          root: {
            display: 'flex',
            alignItems: 'center',
            background: '#F23E3E1A',
          },
          message: {
            color: '#F23E3E'
          },
          icon: {
            color: '#F23E3E'
          }
        }
      }
    }
  })

  return (
    <ThemeProvider theme={theme}>
      <Alert severity="error" sx={{minHeight: 'auto'}}>
        {formNotificationMessage?.message}
      </Alert>
    </ThemeProvider>
  );
};

export default FormNotificationMessage;
